class AudioManager {
  private static instance: AudioManager;
  private audio: HTMLAudioElement | null = null;
  private currentUrl: string | null = null; // зберігаємо URL поточного аудіо

  private constructor() {}

  public static getInstance(): AudioManager {
    if (!AudioManager.instance) {
      AudioManager.instance = new AudioManager();
    }
    return AudioManager.instance;
  }

  public play(url: string) {
    if (this.audio && this.currentUrl === url && this.audio.paused) {
      this.audio.play();
    } else {
      this.stop();
      this.audio = new Audio(url);
      this.currentUrl = url;
      this.audio.play();
    }
  }

  public pause() {
    if (this.audio) {
      this.audio.pause();
    }
  }

  public stop() {
    if (this.audio) {
      this.audio.pause();
      this.audio.currentTime = 0;
      this.audio = null;
      this.currentUrl = null;
    }
  }
}

export const audioManager = AudioManager.getInstance();
